import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

import './plugins';
import { Api, IO, onReady } from './utilities';
import Stash from './stash';

import App from './components/App';
import OrderSummary from './components/screens/OrderSummary';
import OrderDetail from './components/screens/OrderDetail';
import ItemGroups from './components/screens/ItemGroups';
import ItemGroup from './components/screens/ItemGroup';
import ProductSummary from './components/screens/Products';

require('font-awesome/css/font-awesome.css');
require('./assets/sass/app.scss');

// Global/library configuration
// -----------------------------------------------------------------------------
Vue.use(VueRouter);

// Routing
// -----------------------------------------------------------------------------
const router = new VueRouter();

router.map({
  '/': { component: OrderSummary, tab: 'current' },
  '/orders': { component: OrderSummary, tab: 'current' },
  '/orders/completed': { component: OrderSummary, tab: 'completed' },
  '/orders/future': { component: OrderSummary, tab: 'future' },
  '/orders/:id': { component: OrderDetail },
  '/item-groups': { component: ItemGroups },
  '/item-groups/:id': { component: ItemGroup },
  '/products': { component: ProductSummary },
});

// Inject git hash into body
// -----------------------------------------------------------------------------
const $version = document.createElement('code');

$version.id = 'app-version';
$version.textContent = process.env.VERSION || 'DEV';

document.querySelector('body').appendChild($version);

// Offline mode notification
// -----------------------------------------------------------------------------
IO.socket.on('connect', () => $version.classList.remove('offline'));
IO.socket.on('error', () => $version.classList.add('offline'));
IO.socket.on('reconnect_error', () => $version.classList.add('offline'));

// Heartbeat and auth checks
// -----------------------------------------------------------------------------
onReady(async () => {
  let tryingHeartbeat = true;

  while (tryingHeartbeat) {
    try {
      await axios.get(process.env.HEARTBEAT_URL, {
        headers: { Accept: 'application/json' },
        responseType: 'json',
        withCredentials: true,
      });

      tryingHeartbeat = false;
    } catch (error) {
      const twoMinuteMs = 2 * 60 * 1000;
      const fiveMinuteMs = 5 * 60 * 1000;

      const delay =
        Math.floor(Math.random() * (fiveMinuteMs - twoMinuteMs + 1)) +
        twoMinuteMs;
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }

  try {
    const { data } = await axios.get(process.env.AUTH_URL, {
      headers: { Accept: 'application/json' },
      responseType: 'json',
      withCredentials: true,
    });

    Stash.setFulfiller(data);

    // Now show the app's full layout. Since the loader is rendered within `<App />`, it be visible on the next request.
    router.start(App, '#app');

    const res = await Api.get('orders', {
      channel: 'foreground',
      params: { include: 'items,cardAuthorization' },
    });

    Stash.setOrders(res.data.data);
  } catch (error) {
    if (error.response && [401, 403].includes(error.response.status)) {
      window.location.replace(process.env.REAUTH_URL);
    } else {
      throw error; // rethrow if something else went wrong
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js